import React from 'react'
import * as Admin from "../routes/Admin"
import * as AAFF from "../routes/AAFF"
import * as Tecnico from "../routes/Tecnico"
import * as Proveedor from "../routes/Proveedor"
import * as Comercial from "../routes/Comercial"
import * as Consultor from "../routes/Consultor"
import * as ConsulVentas from "../routes/ConsulVentas.jsx"
import * as Admin_cai from "../routes/Admin_cai.jsx"
// import Menu from '../components/Menu/Menu'
// import Navbar from '../components/navbar/navbar'
import { Navbar, Menu } from '../components'
import MenuLegalia from '../components/Menu/MenuLegalia'

function ProtectedRoute(props) {
        //Auth loaded and signed in
        if (props.user?.rol === "ADMIN") {
            if(props.type === 'menuMov'){
                return (
                    <>
                        <Menu logoUrl={props.logoUrl} menu={<Admin.MenuLinks />} routesClientes={<Admin.MenuLinksClientes />} routesPersonal={<Admin.MenuLinksPersonal />} routesListados={<Admin.MenuLinksListado />} routesDashboard={<Admin.MenuLinksDashboard />} routesKae={<Admin.MenuLinksKae />}  /> 
                        <div className='contenedor'>
                            <Admin.RouteBundle />
                        </div>
                    </>
                )
            }else{
                return (
                    <>
                      <Navbar showSidebar = {props.showSidebar} user={props.user} rol = {props.user} routes={<Admin.MenuLinks />} routesClientes={<Admin.MenuLinksClientes />} routesPersonal={<Admin.MenuLinksPersonal />} routesListados={<Admin.MenuLinksListado />} routesDashboard={<Admin.MenuLinksDashboard />} routesKae={<Admin.MenuLinksKae />} />
                      <div className='contenedor'>
                        <Admin.RouteBundle />
                      </div>
                    </>
                )
            }
        } 
    
         if (props.user?.rol === "AAFF") {
            if(props.type === 'menuMov'){
                if (props.user?.tieneLegalia) {
                    return (
                        <>
                            <MenuLegalia />
                            <div className='contenedor'>
                                <AAFF.RouteBundle user={props.user}/>
                            </div>
                        </>
                    )
                }
                return (
                    <>
                        <Menu logoUrl={props.logoUrl} routesClientes={<AAFF.MenuLinksClientes user={props.user}/>} routesListados={<AAFF.MenuLinksListado />} routesKae={props.user?.tieneKae ? <AAFF.MenuLinksKae /> : undefined} />
                        <div className='contenedor'>
                            <AAFF.RouteBundle user={props.user}/>
                        </div>
                    </>
                )
            }else{
                return (
                    <>
                      <Navbar showSidebar = {props.showSidebar} user={props.user} rol = {props.user} routesClientes={<AAFF.MenuLinksClientes user={props.user} />} routesListados={<AAFF.MenuLinksListado />} routesKae={props.user?.tieneKae ? <AAFF.MenuLinksKae /> : undefined}/>
                      <div className='contenedor'>
                        <AAFF.RouteBundle user={props.user} />
                      </div>
                    </>
                )
            }
        }
        if (props.user?.rol === "TECH" || props.user?.rol === "TECH_COOR") {
            const tieneKae = props.user?.gruposServicios?.includes(4);
            const esCoordinador = props.user?.rol === "TECH_COOR";
            if(props.type === 'menuMov'){
                return (
                    <>
                        <Menu logoUrl={props.logoUrl} menu={<Tecnico.MenuLinks />} routesClientes={<Tecnico.MenuLinksClientes />} routesDashboard={esCoordinador ? <Tecnico.MenuLinksDashboard /> : undefined} routesKae={tieneKae ? <Tecnico.MenuLinksKae /> : undefined} />
                        <div className='contenedor'>
                            <Tecnico.RouteBundle />
                        </div>
                    </>
                )
            }else{
                return (
                    <>
                      <Navbar showSidebar = {props.showSidebar} user={props.user} rol = {props.user} routes={<Tecnico.MenuLinks />} routesClientes={<Tecnico.MenuLinksClientes />} routesDashboard={esCoordinador ? <Tecnico.MenuLinksDashboard /> : undefined} routesKae={tieneKae ? <Tecnico.MenuLinksKae /> : undefined} />
                      <div className='contenedor'>
                        <Tecnico.RouteBundle />
                      </div>
                    </>
                )
            }
        }
        if (props.user?.rol === "SUPP") {
            if(props.type === 'menuMov'){
                return (
                    <>
                        <Menu logoUrl={props.logoUrl} routesClientes={<Proveedor.MenuLinksClientes />} /> 
                        <div className='contenedor'>
                            <Proveedor.RouteBundle />
                        </div>
                    </>
                )
            }else{
                return (
                    <>
                      <Navbar showSidebar = {props.showSidebar} user={props.user} rol = {props.user} routesClientes={<Proveedor.MenuLinksClientes />} />
                      <div className='contenedor'>
                        <Proveedor.RouteBundle />
                      </div>
                    </>
                )
            }
        }
        if (props.user?.rol === "COMM") {
            if(props.type === 'menuMov'){
                return (
                    <>
                        <Menu logoUrl={props.logoUrl} routesClientes={<Comercial.MenuLinksClientes />} routesListados={<Comercial.MenuLinksListado />} routesKae={<Comercial.MenuLinksKae />} />
                        <div className='contenedor'>
                            <Comercial.RouteBundle />
                        </div>
                    </>
                )
            }else{
                return (
                    <>
                      <Navbar showSidebar = {props.showSidebar} user={props.user} rol = {props.user} routesClientes={<Comercial.MenuLinksClientes />} routesListados={<Comercial.MenuLinksListado />} routesKae={<Comercial.MenuLinksKae />} />
                      <div className='contenedor'>
                        <Comercial.RouteBundle />
                      </div>
                    </>
                )
            }
        }
        if (props.user?.rol === "CONSUL") {
            if(props.type === 'menuMov'){
                return (
                    <>
                        <Menu logoUrl={props.logoUrl} menu={<Consultor.MenuLinks />} routesClientes={<Consultor.MenuLinksClientes />} routesPersonal={<Consultor.MenuLinksPersonal />} routesListados={<Consultor.MenuLinksListado />} /> 
                        <div className='contenedor'>
                            <Consultor.RouteBundle />
                        </div>
                    </>
                )
            }else{
                return (
                    <>
                      <Navbar showSidebar = {props.showSidebar} user={props.user} rol = {props.user} routes={<Consultor.MenuLinks />} routesClientes={<Consultor.MenuLinksClientes />} routesPersonal={<Consultor.MenuLinksPersonal />} routesListados={<Consultor.MenuLinksListado />} />
                      <div className='contenedor'>
                        <Consultor.RouteBundle />
                      </div>
                    </>
                )
            }
        }
        if (props.user?.rol === "VENT") {
            if(props.type === 'menuMov'){
                return (
                    <>
                        <Menu logoUrl={props.logoUrl} menu={<ConsulVentas.MenuLinks />} routesClientes={<ConsulVentas.MenuLinksClientes />} routesPersonal={<ConsulVentas.MenuLinksPersonal />} routesListados={<ConsulVentas.MenuLinksListado />} routesKae={<ConsulVentas.MenuLinksKae />} />
                        <div className='contenedor'>
                            <ConsulVentas.RouteBundle />
                        </div>
                    </>
                )
            }else{
                return (
                    <>
                      <Navbar showSidebar = {props.showSidebar} user={props.user} rol = {props.user} routes={<ConsulVentas.MenuLinks />} routesClientes={<ConsulVentas.MenuLinksClientes />} routesPersonal={<ConsulVentas.MenuLinksPersonal />} routesListados={<ConsulVentas.MenuLinksListado />} routesKae={<ConsulVentas.MenuLinksKae />} />
                      <div className='contenedor'>
                        <ConsulVentas.RouteBundle />
                      </div>
                    </>
                )
            }
        }
        if (props.user?.rol === "ADMIN_CAI") {
            if(props.type === 'menuMov'){
                return (
                    <>
                        <Menu logoUrl={props.logoUrl} routesClientes={<Admin_cai.MenuLinksClientes rol={props.user?.rol} />} /> 
                        <div className='contenedor'>
                            <Admin_cai.RouteBundle />
                        </div>
                    </>
                )
            }else{
                return (
                    <>
                      <Navbar showSidebar = {props.showSidebar} user={props.user} rol = {props.user} routesClientes={<Admin_cai.MenuLinksClientes rol={props.user?.rol} />} />
                      <div className='contenedor'>
                        <Admin_cai.RouteBundle />
                      </div>
                    </>
                )
            }
        } 
        return null; //Loading
    
}

export default ProtectedRoute;
